/** @format */

import { useEffect, useRef, useState } from 'react';
import Page from 'src/components/Page';
import Breadcrumb from 'src/components/Breadcrumb';
import { WidgetGrid } from 'src/components';
import { useDispatch, useSelector } from 'src/store';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getDashboard, setCurrentUserDashboard } from 'src/slices/users';
import { Button } from 'src/components/button';
import Skeleton from '@mui/material/Skeleton';
import { flushSync } from 'react-dom';

const startViewTransition = callback => {
  if (document.startViewTransition) {
    document.startViewTransition(() => {
      flushSync(callback);
    });
  } else {
    callback();
  }
};

const DashboardByIdView = () => {
  const { dashboardId } = useParams();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { dashboardLoading, dashboardError, dashboardInfo } = useSelector(state => state.users);

  const [displayedContent, setDisplayedContent] = useState({ loading: true, info: null });
  const prevLoadingRef = useRef(dashboardLoading);

  useEffect(() => {
    dispatch(getDashboard({ dashboardId }));
    dispatch(setCurrentUserDashboard(Number(dashboardId)));
  }, [dashboardId, dispatch]);

  useEffect(() => {
    const wasLoading = prevLoadingRef.current;
    prevLoadingRef.current = dashboardLoading;

    if (wasLoading && !dashboardLoading) {
      startViewTransition(() => {
        setDisplayedContent({ loading: false, info: dashboardInfo });
      });
    } else if (dashboardLoading && !wasLoading) {
      setDisplayedContent({ loading: true, info: null });
    } else if (!dashboardLoading) {
      setDisplayedContent({ loading: false, info: dashboardInfo });
    }
  }, [dashboardLoading, dashboardInfo]);

  const handleBackToMainDashboard = () => {
    dispatch(setCurrentUserDashboard(null));
    navigate(`/dashboard`);
  };

  if (!dashboardLoading && dashboardError) {
    return <Navigate to="/404" replace />;
  }

  const breadcrumbData = [
    {
      title: t('dashboard.title'),
      link: '/dashboard'
    },
    {
      title: dashboardInfo?.currentUserDashboard?.[dashboardId] || (
        <Skeleton variant="text" width={100} height={20} style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)' }} />
      )
    }
  ];

  return (
    <Page className={`dashboard`} title={t('dashboard.title')}>
      <Breadcrumb data={breadcrumbData} />
      <WidgetGrid dashboardInfo={dashboardInfo} />
      <div className="container" style={{ marginTop: 60 }}>
        <Button label={t('common.button.backbtn')} secondary onClick={handleBackToMainDashboard} />
      </div>
    </Page>
  );
};

export default DashboardByIdView;
